/* eslint-disable react/no-danger */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router-dom';
import {
  getInsuranceBookingDetails,
  getUserDetails,
} from '../../api/profileApi';
import {
  getObjectFromLS,
  getStringFromLS,
  getValueFromAppConfig,
  getUserAgentId,
} from '../../shared/helper-utils/localStorage';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
  DATE_MONTH_YEAR_FORMAT,
} from '../../shared/constants/Constants';
import {
  convertTravelTime,
  formatDate,
  getNewDate,
  hideHeaderFooter,
  isEmpty,
  showHeaderFooter,
} from '../../shared/helper-utils/appUtils';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import NumberToWords from '../../shared/components/NumberToWords';
import {
  APP_AGENT_LOGO_URL,
  APP_LOGO_URL,
  APP_USER_PROFILE,
} from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';

function InsuranceVoucher() {
  const { transactionId } = useParams();
  const [isLoading, setLoading] = useState(false);
  const [hasTicket, setHasTicket] = useState(undefined);
  const [alert, setAlert] = useState(undefined);
  const [bookingDetails, setBookingDetails] = useState({});
  const [agent, setAgent] = useState({});
  const [insurancePax, setInsurancePax] = useState([]);
  const { appConfig } = useAppContext();

  const getBusBookingDetails = async () => {
    setLoading(true);
    const response = await getInsuranceBookingDetails(transactionId);
    if (response?.Root?.Status === 'OK') {
      const data = response.Root?.Result?.TravelInsuranceInvoice || {};
      if (
        !isEmpty(data.TravelInsurancePassengers) &&
        !isEmpty(data.TravelInsurancePassengers.TravelInsurancePassenger)
      ) {
        setInsurancePax(
          Array.isArray(data.TravelInsurancePassengers.TravelInsurancePassenger)
            ? data.TravelInsurancePassengers.TravelInsurancePassenger
            : [data.TravelInsurancePassengers.TravelInsurancePassenger],
        );
      }
      setBookingDetails(data);
      setHasTicket(true);
    } else {
      setAlert({
        variant: 'error',
        title: 'Bus Bookings Details',
        description: response?.Root?.Message,
      });
      setHasTicket(false);
    }
    setLoading(false);
  };
  const getUserData = async () => {
    setLoading(true);
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getUserDetails(userProfile?.agentId);
    if (response.ApiStatus.Status === 'OK') {
      const user = response.ApiStatus.Result.User;
      setAgent(user);
    }
    setLoading(false);
  };
  useEffect(() => {
    getBusBookingDetails();
    getUserData();
  }, []);

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const getTime = (time) => {
    return `${Math.floor(time / 60)}:${time % 60}`;
  };
  let insurance = null;

  try {
    insurance = bookingDetails.InsuranceDetails
      ? JSON.parse(bookingDetails.InsuranceDetails)
      : null;
  } catch {
    insurance = null;
  }

  return (
    <section className="flight-ticket-invoice-page">
      <AppLoading isLoading={isLoading} />
      <section className="print-links d-flex flex-column  hide-in-print">
        <a onClick={() => window.print()}>
          <img src="/images/others/print_sidebutton.png" alt="" />
        </a>
        <a href={NAVIGATION_ROUTES.LANDING}>
          <img src="/images/others/home_sidebutton.png" alt="" />
        </a>
      </section>
      {alert && (
        <AppAlert
          showIcon
          variant={alert.variant}
          title={alert.title}
          onHide={() => setAlert(undefined)}
          description={alert.description}
        />
      )}
      {hasTicket !== undefined && hasTicket && (
        <div
          style={{
            padding: '1rem 10px',
            width: '900px',
            marginInline: 'auto',
            backgroundColor: '#fff',
          }}
        >
          <div style={{ border: '1px solid #000' }}>
            <div
              style={{
                padding: '10px',
                fontWeight: '600',
                borderBottom: '1px solid #000',
              }}
              className="d-flex justify-content-between align-items-center"
            >
              <div className="flex-1">
                <img
                  src={getStringFromLS(APP_AGENT_LOGO_URL)}
                  alt=""
                  style={{ maxHeight: `${appConfig.logoHeight}px` }}
                  // eslint-disable-next-line no-return-assign
                  onError={(e) =>
                    (e.target.src = getStringFromLS(APP_LOGO_URL))
                  }
                />
              </div>
              <div className="flex-1 text-start">INVOICE</div>
            </div>
            <div
              style={{
                padding: '4px 10px',
                fontSize: '14px',
                fontWeight: '300',
              }}
              className="d-flex flex-column"
            >
              {getValueFromAppConfig('INVADDRESS')
                .split('<br>')
                .map((d, index) => (
                  <span key={index}>{d}</span>
                ))}
            </div>
            {Object.keys(agent).length > 0 && (
              <div
                className="py-1 fs-12 d-flex px-2"
                style={{ border: '1px solid #000' }}
              >
                <div className="d-flex flex-column flex-1 gap-1">
                  <span>
                    <b>To M/s:</b> {agent.Company}
                    <br />
                  </span>
                  <span>
                    <b>Address: </b>
                    {agent.Address1},{agent.Address2},{agent.City},{agent.State}
                    ,{agent.PinCode},
                    <br />
                  </span>
                  <span>
                    <b>Email: </b>
                    {agent.ContactEmail}
                    <br />
                  </span>
                  <span>
                    <b>Phone: </b>
                    {agent.ContactNumber}
                    <br />
                  </span>
                  <span>
                    <b>GSTN No: </b> {agent.Gst_number}
                  </span>
                </div>
                <div className="d-flex justify-content-end flex-1">
                  <div className="d-flex flex-column gap-1">
                    <span>
                      <b>Invoice Date: </b>{' '}
                      {bookingDetails.TxDate.split(' ')[0] &&
                        formatDate(
                          getNewDate(bookingDetails.TxDate.split(' ')[0]),
                          DATE_MONTH_YEAR_FORMAT,
                        )}
                    </span>
                    <span>
                      <b>Invoice No: </b> {bookingDetails.InvoiceNumber}
                    </span>
                    <span>
                      <b>HSN/SAC: </b> 998551
                    </span>
                  </div>
                </div>
              </div>
            )}
            <div className="text-center p-1 fs-12 fw-500">
              Category Type : Insurance
            </div>
            <div className="mb-3">
              <table className="table-bordered fs-12 w-100 ">
                <thead>
                  <tr>
                    <th colSpan={3} className="text-center">
                      Policy details
                    </th>
                  </tr>
                  <tr>
                    <th>Policy Name</th>
                    <th>Policy Details</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>{bookingDetails.InsuranceName}</td>
                    <td>
                      {insurance ? (
                        <div className="insurance-card">
                          <div>
                            <b>Plan:</b> {insurance.Response.Itinerary.PlanName}
                          </div>
                          <div>
                            <b>Policy No:</b>{' '}
                            {insurance.Response.Itinerary.PaxInfo[0].PolicyNo}
                          </div>
                          <div>
                            <b>Passenger:</b>{' '}
                            {insurance.Response.Itinerary.PaxInfo[0].FirstName}{' '}
                            {insurance.Response.Itinerary.PaxInfo[0].LastName}
                          </div>
                          <div>
                            <b>Travel Dates:</b>{' '}
                            {insurance.Response.Itinerary.PolicyStartDate.slice(
                              0,
                              10,
                            )}{' '}
                            →{' '}
                            {insurance.Response.Itinerary.PolicyEndDate.slice(
                              0,
                              10,
                            )}
                          </div>
                          <div>
                            <b>Destination:</b>{' '}
                            {
                              insurance.Response.Itinerary.PaxInfo[0]
                                .MajorDestination
                            }
                          </div>

                          <a
                            href={
                              insurance.Response.Itinerary.PaxInfo[0]
                                .DocumentURL
                            }
                            target="_blank"
                            rel="noreferrer"
                            className="insurance-link"
                          >
                            View Policy PDF
                          </a>
                        </div>
                      ) : (
                        '-'
                      )}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="mb-2">
              <table className="table-bordered fs-12 w-100 ">
                <thead>
                  <tr>
                    <th colSpan={4} className="text-center">
                      Insurance Passenger Details
                    </th>
                  </tr>
                  <tr>
                    <th> Name</th>
                    <th>Policy Number</th>
                  </tr>
                </thead>
                <tbody>
                  {insurancePax.map((pax, index) => (
                    <tr key={index}>
                      <td>{pax.PaxName}</td>
                      <td>{pax.PolicyNumber}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <div className="fs-12 d-flex justify-content-between gap-1 px-2 border-bottom pb-2">
              <div className="d-flex align-items-end">
                <p className="mb-0">
                  <b>Amount in Words : </b>
                  <span className="text-capitalize fw-300">
                    <NumberToWords
                      number={bookingDetails.TotalInvoice.toFixed(2)}
                    />
                  </span>
                </p>
              </div>
              <div className="d-flex justify-content-end">
                <table>
                  <tbody>
                    <tr>
                      <td>[ + ] Basic</td>
                      <td className="px-2">:</td>
                      <td className="text-end">{bookingDetails.BaseFare}</td>
                    </tr>
                    <tr>
                      <td>[ + ] Taxes</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.Tax?.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] Service Charges</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.ServiceTax?.toFixed(2)}
                      </td>
                    </tr>
                    {/* 
                    <tr>
                      <td>[ + ] SGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.sgstonhc.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] CGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.cgstonhc.toFixed(2)}
                      </td>
                    </tr>
                    <tr>
                      <td>[ + ] IGST @ 9%</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.igstonhc.toFixed(2)}
                      </td>
                    </tr> */}
                    <tr className="fw-bold border-bottom ">
                      <td>Total Billing Amount (Rs)</td>
                      <td className="px-2">:</td>
                      <td className="text-end">
                        {bookingDetails.TotalInvoice?.toFixed(2)}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div className="p-2 fs-12 fw-600">
              <div className="d-flex justify-content-between">
                <div className="d-flex gap-1 flex-column flex-1">
                  <span>
                    <b>Terms & Conditions: </b>
                  </span>
                  <ul>
                    <li>
                      This is computer generated invoice signature not required.
                    </li>
                    <li>
                      Refunds Cancellations are subject to Supplier&apos;s
                      approval
                    </li>
                    <li>
                      Kindly check all details carefully to avoid unnecessary
                      complications.
                    </li>
                    <li>
                      All transactions between the Company and the Agency are
                      subject to the Company&apos;s Privacy Policy and Terms and
                      Conditions
                    </li>
                    <li>
                      All invoices and credit notes are confidential and should
                      not be disclosed to third parties without prior written
                      consent from the Company.
                    </li>
                  </ul>
                </div>
                <div className="d-flex flex-column justify-content-end align-items-center mb-3">
                  <p>{getValueFromAppConfig('COMPANYNAME')}</p>
                  <span>Authorised Signature</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default InsuranceVoucher;
